// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__0hIEk","employee-header__buttons":"Header_employee-header__buttons__bmOA-","employee-header-item":"Header_employee-header-item__FPWhN"};